angular.module( 'acme.view.application.membership.offerings.create.lifecycle.modals.remove', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.offerings.create.lifecycle.modals.remove.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipOfferingsCreateLifecycleModalsRemove = {
        name: 'application.membership.offerings.create.lifecycle.modals.remove',
        url: '/membership/offerings/create/lifecycle/modals/remove',
        views: {
          "main": {
            controller: 'MembershipOfferingsCreateLifecycleModalsRemoveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/offerings/create/lifecycle/modals/remove/remove.tpl.html'
          }
        },
        data: {
          pageTitle: '      ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipOfferingsCreateLifecycleModalsRemove);
});
